export const icons = {
	settings: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M10.109,7.031A4.177,4.177,0,0,0,10.25,6a4.177,4.177,0,0,0-.141-1.031l1.2-.883a.5.5,0,0,0,.136-.653l-.5-.866a.5.5,0,0,0-.634-.208l-1.357.6A4.228,4.228,0,0,0,7.162,1.931L7,.445A.5.5,0,0,0,6.5,0h-1A.5.5,0,0,0,5,.445L4.838,1.931A4.228,4.228,0,0,0,3.045,2.954l-1.357-.6a.5.5,0,0,0-.634.208l-.5.866a.5.5,0,0,0,.136.653l1.2.883A4.177,4.177,0,0,0,1.75,6a4.177,4.177,0,0,0,.141,1.031l-1.2.883a.5.5,0,0,0-.136.653l.5.866a.5.5,0,0,0,.433.25.51.51,0,0,0,.2-.042l1.357-.6a4.228,4.228,0,0,0,1.793,1.023L5,11.555A.5.5,0,0,0,5.5,12h1a.5.5,0,0,0,.5-.445l.165-1.486A4.228,4.228,0,0,0,8.955,9.046l1.357.6a.51.51,0,0,0,.2.042.5.5,0,0,0,.433-.25l.5-.866a.5.5,0,0,0-.136-.653ZM6,8A2,2,0,1,1,8,6,2,2,0,0,1,6,8Z"></path>
			</g>
		</svg>
	),
	code: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M4.707,2.293a1,1,0,0,0-1.414,0l-3,3a1,1,0,0,0,0,1.414l3,3A1,1,0,1,0,4.707,8.293L2.414,6,4.707,3.707A1,1,0,0,0,4.707,2.293Z"></path>{" "}
				<path
					d="M8.707,2.293A1,1,0,1,0,7.293,3.707L9.586,6,7.293,8.293A1,1,0,1,0,8.707,9.707l3-3a1,1,0,0,0,0-1.414Z"
					data-color="color-2"
				></path>
			</g>
		</svg>
	),
	download: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M11,10H1a1,1,0,0,0,0,2H11a1,1,0,0,0,0-2Z"></path>
				<path
					data-color="color-2"
					d="M6.5,0h-1A.5.5,0,0,0,5,.5V3H2.5a.5.5,0,0,0-.376.829l3.5,4a.5.5,0,0,0,.752,0l3.5-4A.5.5,0,0,0,9.5,3H7V.5A.5.5,0,0,0,6.5,0Z"
				></path>
			</g>
		</svg>
	),
	search: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M11.707,10.293l-2.54-2.54A5.015,5.015,0,1,0,7.753,9.167l2.54,2.54a1,1,0,0,0,1.414-1.414ZM2,5A3,3,0,1,1,5,8,3,3,0,0,1,2,5Z"></path>
			</g>
		</svg>
	),
	folder: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M11.5,2H5.809L4.947.277A.5.5,0,0,0,4.5,0H.5A.5.5,0,0,0,0,.5V9a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V2.5A.5.5,0,0,0,11.5,2Z"></path>
			</g>
		</svg>
	),
	arrowRight: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M9.707,5.293l-5-5A1,1,0,0,0,3.293,1.707L7.586,6,3.293,10.293a1,1,0,1,0,1.414,1.414l5-5A1,1,0,0,0,9.707,5.293Z"></path>
			</g>
		</svg>
	),
	arrowDown: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M11.5,2H.5a.5.5,0,0,0-.412.783l5.5,8a.5.5,0,0,0,.824,0l5.5-8A.5.5,0,0,0,11.5,2Z"></path>
			</g>
		</svg>
	),
	heart: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M10.988,2.055A3.339,3.339,0,0,0,6.28,1.893c-.058.054-.113.109-.168.169s-.085.094-.125.142c-.041-.049-.084-.1-.128-.145A3.336,3.336,0,0,0,1.146,1.9c-.058.052-.113.107-.165.163A3.7,3.7,0,0,0,.989,7.1L5.63,11.85a.5.5,0,0,0,.715,0L10.989,7.1A3.614,3.614,0,0,0,10.988,2.055Z"></path>
			</g>
		</svg>
	),
	arrowUp: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M6.412,1.217a.518.518,0,0,0-.824,0l-5.5,8A.5.5,0,0,0,.5,10h11a.5.5,0,0,0,.412-.783Z"></path>
			</g>
		</svg>
	),
	plus: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M11,5H7V1A1,1,0,0,0,5,1V5H1A1,1,0,0,0,1,7H5v4a1,1,0,0,0,2,0V7h4a1,1,0,0,0,0-2Z"></path>
			</g>
		</svg>
	),
	cog: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M10.109,7.031A4.177,4.177,0,0,0,10.25,6a4.177,4.177,0,0,0-.141-1.031l1.2-.883a.5.5,0,0,0,.136-.653l-.5-.866a.5.5,0,0,0-.634-.208l-1.357.6A4.228,4.228,0,0,0,7.162,1.931L7,.445A.5.5,0,0,0,6.5,0h-1A.5.5,0,0,0,5,.445L4.838,1.931A4.228,4.228,0,0,0,3.045,2.954l-1.357-.6a.5.5,0,0,0-.634.208l-.5.866a.5.5,0,0,0,.136.653l1.2.883A4.177,4.177,0,0,0,1.75,6a4.177,4.177,0,0,0,.141,1.031l-1.2.883a.5.5,0,0,0-.136.653l.5.866a.5.5,0,0,0,.433.25.51.51,0,0,0,.2-.042l1.357-.6a4.228,4.228,0,0,0,1.793,1.023L5,11.555A.5.5,0,0,0,5.5,12h1a.5.5,0,0,0,.5-.445l.165-1.486A4.228,4.228,0,0,0,8.955,9.046l1.357.6a.51.51,0,0,0,.2.042.5.5,0,0,0,.433-.25l.5-.866a.5.5,0,0,0-.136-.653ZM6,8A2,2,0,1,1,8,6,2,2,0,0,1,6,8Z"></path>
			</g>
		</svg>
	),
	luminosity: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path
					d="M6,2a.5.5,0,0,0,.5-.5V.5a.5.5,0,0,0-1,0v1A.5.5,0,0,0,6,2Z"
					data-color="color-2"
				></path>
				<path
					d="M9.182,3.318a.5.5,0,0,0,.354-.147l.707-.707a.5.5,0,0,0-.707-.707l-.707.707a.5.5,0,0,0,.353.854Z"
					data-color="color-2"
				></path>
				<path
					d="M11.5,5.5h-1a.5.5,0,0,0,0,1h1a.5.5,0,0,0,0-1Z"
					data-color="color-2"
				></path>
				<path
					d="M9.536,8.829a.5.5,0,0,0-.707.707l.707.707a.5.5,0,0,0,.707-.707Z"
					data-color="color-2"
				></path>
				<path
					d="M6,10a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,1,0v-1A.5.5,0,0,0,6,10Z"
					data-color="color-2"
				></path>
				<path
					d="M2.464,8.829l-.707.707a.5.5,0,0,0,.707.707l.707-.707a.5.5,0,0,0-.707-.707Z"
					data-color="color-2"
				></path>
				<path
					d="M2,6a.5.5,0,0,0-.5-.5H.5a.5.5,0,0,0,0,1h1A.5.5,0,0,0,2,6Z"
					data-color="color-2"
				></path>
				<path
					d="M2.464,3.171a.5.5,0,0,0,.707-.707l-.707-.707a.5.5,0,0,0-.707.707Z"
					data-color="color-2"
				></path>
				<circle cx="6" cy="6" r="3"></circle>
			</g>
		</svg>
	),
	hue: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M11.936,1.256A.5.5,0,0,0,11.5,1H.5a.5.5,0,0,0-.427.761l5.5,9a.5.5,0,0,0,.854,0l5.5-9A.5.5,0,0,0,11.936,1.256Z"></path>
			</g>
		</svg>
	),
	saturation: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M6,0a6,6,0,1,0,6,6A6,6,0,0,0,6,0ZM2,6A4,4,0,0,1,6,2v8A4,4,0,0,1,2,6Z"></path>
			</g>
		</svg>
	),
	dots: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<circle cx="9.5" cy="2.5" r="2.5" data-color="color-2"></circle>{" "}
				<circle cx="2.5" cy="2.5" r="2.5"></circle>{" "}
				<circle cx="9.5" cy="9.5" r="2.5"></circle>{" "}
				<circle cx="2.5" cy="9.5" r="2.5" data-color="color-2"></circle>
			</g>
		</svg>
	),
	steps: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<circle cx="6" cy="6" r="1.5" data-color="color-2"></circle>{" "}
				<circle cx="10.5" cy="6" r="1.5"></circle>{" "}
				<circle cx="1.5" cy="6" r="1.5"></circle>
			</g>
		</svg>
	),
	next: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M7.829,3.124A.5.5,0,0,0,7,3.5V6H4A2,2,0,0,1,4,2H5A1,1,0,0,0,5,0H4A4,4,0,0,0,4,8H7v2.5a.5.5,0,0,0,.829.376l4-3.5a.5.5,0,0,0,0-.752Z"></path>
			</g>
		</svg>
	),
	prev: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M8,0H7A1,1,0,0,0,7,2H8A2,2,0,0,1,8,6H5V3.5a.5.5,0,0,0-.829-.376l-4,3.5a.5.5,0,0,0,0,.752l4,3.5A.5.5,0,0,0,4.5,11a.5.5,0,0,0,.5-.5V8H8A4,4,0,0,0,8,0Z"></path>
			</g>
		</svg>
	),
	close: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M10.707,1.293a1,1,0,0,0-1.414,0L6,4.586,2.707,1.293A1,1,0,0,0,1.293,2.707L4.586,6,1.293,9.293a1,1,0,1,0,1.414,1.414L6,7.414l3.293,3.293a1,1,0,0,0,1.414-1.414L7.414,6l3.293-3.293A1,1,0,0,0,10.707,1.293Z"></path>
			</g>
		</svg>
	),
	copy: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M10.217,6.636,7.254,9.6A3.077,3.077,0,0,1,2.9,5.249L6.124,2.027a1.847,1.847,0,0,1,2.547,0,1.8,1.8,0,0,1,0,2.547L5.708,7.536a.526.526,0,0,1-.743,0,.528.528,0,0,1,0-.743L7.154,4.6a.75.75,0,1,0-1.06-1.06L3.9,5.733A2.026,2.026,0,0,0,6.769,8.6L9.731,5.635A3.3,3.3,0,0,0,5.063.967L1.843,4.188A4.576,4.576,0,0,0,8.314,10.66L11.277,7.7a.75.75,0,0,0-1.06-1.06Z"></path>
			</g>
		</svg>
	),
	paste: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M9,1A1,1,0,0,0,8,0H1A1,1,0,0,0,0,1V9a1,1,0,0,0,1,1H4.5V4.5a1,1,0,0,1,1-1H9Z"></path>
				<rect
					x="6"
					y="5"
					width="6"
					height="7"
					rx="0.5"
					data-color="color-2"
				></rect>
			</g>
		</svg>
	),
	clock: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M6,12a6,6,0,1,1,6-6A6.006,6.006,0,0,1,6,12ZM6,2a4,4,0,1,0,4,4A4,4,0,0,0,6,2Z"></path>{" "}
				<path
					d="M8.5,6.5H6A.5.5,0,0,1,5.5,6V3.5a.5.5,0,0,1,1,0v2h2a.5.5,0,0,1,0,1Z"
					data-color="color-2"
				></path>
			</g>
		</svg>
	),
	direction: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<circle cx="2" cy="10" r="2"></circle>
				<circle cx="10" cy="2" r="2"></circle>
				<path
					d="M10,4.75a.75.75,0,0,0-.75.75v3a1.25,1.25,0,0,1-2.5,0v-5a2.75,2.75,0,0,0-5.5,0v3a.75.75,0,0,0,1.5,0v-3a1.25,1.25,0,0,1,2.5,0v5a2.75,2.75,0,0,0,5.5,0v-3A.75.75,0,0,0,10,4.75Z"
					data-color="color-2"
				></path>
			</g>
		</svg>
	),
	randomize: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M11.854.036a.25.25,0,0,0-.272.053L10.061,1.594A5.937,5.937,0,0,0,6,0,6,6,0,0,0,.5,3.6a1,1,0,0,0,.516,1.316.978.978,0,0,0,.4.084,1,1,0,0,0,.917-.6A4,4,0,0,1,6,2,3.954,3.954,0,0,1,8.636,3L6.941,4.681a.251.251,0,0,0-.06.259.248.248,0,0,0,.209.166l4.64.514.028,0a.248.248,0,0,0,.25-.25V.267A.251.251,0,0,0,11.854.036Z"></path>
				<path
					data-color="color-2"
					d="M.146,11.964a.229.229,0,0,0,.1.019.251.251,0,0,0,.176-.072l1.521-1.5A5.937,5.937,0,0,0,6,12a6,6,0,0,0,5.5-3.6,1,1,0,0,0-1.833-.8A4,4,0,0,1,6,10,3.954,3.954,0,0,1,3.364,9l1.7-1.677a.251.251,0,0,0,.06-.259.248.248,0,0,0-.209-.166L.27,6.38a.27.27,0,0,0-.195.061.252.252,0,0,0-.083.187v5.105A.251.251,0,0,0,.146,11.964Z"
				></path>
			</g>
		</svg>
	),
	grid: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M10,0H2A2,2,0,0,0,0,2v8a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V2A2,2,0,0,0,10,0Zm0,5H7V2h3ZM5,2V5H2V2ZM2,7H5v3H2Zm5,3V7h3v3Z"></path>
			</g>
		</svg>
	),
	moon: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M11.326,8.237A.5.5,0,0,0,10.905,8,6.023,6.023,0,0,1,5,2,6.023,6.023,0,0,1,5.125.779.5.5,0,0,0,4.511.193a6,6,0,1,0,6.832,8.529A.5.5,0,0,0,11.326,8.237Z"></path>
			</g>
		</svg>
	),
	hamburger: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M11,9H1a1,1,0,0,0,0,2H11a1,1,0,0,0,0-2Z"></path>{" "}
				<path d="M11,1H1A1,1,0,0,0,1,3H11a1,1,0,0,0,0-2Z"></path>{" "}
				<path
					d="M11,5H1A1,1,0,0,0,1,7H11a1,1,0,0,0,0-2Z"
					data-color="color-2"
				></path>
			</g>
		</svg>
	),
	design: (
		<svg x="0px" y="0px" width="16px" height="16px" viewBox="0 0 16 16">
			<g transform="translate(0, 0)">
				<path d="M14,7.829V14H2V2H8.172l2-2H1A1,1,0,0,0,0,1V15a1,1,0,0,0,1,1H15a1,1,0,0,0,1-1V5.828Z"></path>
				<path
					d="M15.4.6a2.175,2.175,0,0,0-3,0l-3.7,3.7a4.746,4.746,0,0,1,1.916,1.244,5.269,5.269,0,0,1,1.065,1.775L15.4,3.6A2.175,2.175,0,0,0,15.4.6Z"
					data-color="color-2"
				></path>
				<path
					d="M4.937,6.9c-1.2,1.2-1.4,5.7-1.4,5.7s4.4-.4,5.6-1.5a2.987,2.987,0,0,0,0-4.2A2.9,2.9,0,0,0,4.937,6.9Z"
					data-color="color-2"
				></path>
			</g>
		</svg>
	),
	gridBig: (
		<svg x="0px" y="0px" width="16px" height="16px" viewBox="0 0 16 16">
			<g transform="translate(0, 0)">
				<rect width="4" height="4" rx=".5" ry=".5"></rect>
				<rect x="6" width="4" height="4" rx=".5" ry=".5"></rect>
				<rect
					data-color="color-2"
					x="12"
					width="4"
					height="4"
					rx=".5"
					ry=".5"
				></rect>
				<rect y="6" width="4" height="4" rx=".5" ry=".5"></rect>
				<rect
					data-color="color-2"
					x="6"
					y="6"
					width="4"
					height="4"
					rx=".5"
					ry=".5"
				></rect>
				<rect x="12" y="6" width="4" height="4" rx=".5" ry=".5"></rect>
				<rect
					data-color="color-2"
					y="12"
					width="4"
					height="4"
					rx=".5"
					ry=".5"
				></rect>
				<rect x="6" y="12" width="4" height="4" rx=".5" ry=".5"></rect>
				<rect x="12" y="12" width="4" height="4" rx=".5" ry=".5"></rect>
			</g>
		</svg>
	),
	bigLove: (
		<svg x="0px" y="0px" width="16px" height="16px" viewBox="0 0 16 16">
			<g transform="translate(0, 0)">
				<path d="M7.313,14.705c.386,.365,.989,.365,1.374,0l5.995-5.668c1.757-1.757,1.757-4.607,0-6.364-1.757-1.757-4.607-1.757-6.364,0-.121,.121-.214,.259-.318,.389-.104-.13-.197-.268-.318-.389C5.925,.916,3.075,.916,1.318,2.673S-.439,7.28,1.318,9.037l5.995,5.668Z"></path>
			</g>
		</svg>
	),
	_arrowDown: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M5.292,11.706a.99.99,0,0,0,.326.217.986.986,0,0,0,.764,0,.99.99,0,0,0,.326-.217l4-4A1,1,0,1,0,9.293,6.293L7,8.586V1A1,1,0,0,0,5,1V8.586L2.707,6.293A1,1,0,0,0,1.293,7.707Z"></path>
			</g>
		</svg>
	),
	_arrowUp: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M2.707,5.707,5,3.414V11a1,1,0,0,0,2,0V3.414L9.293,5.707a1,1,0,0,0,1.414-1.414l-4-4a1,1,0,0,0-1.414,0l-4,4A1,1,0,0,0,2.707,5.707Z"></path>
			</g>
		</svg>
	),
	tag: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M6.414,12A1.993,1.993,0,0,1,5,11.414L.293,6.707A1,1,0,0,1,0,6V1A1,1,0,0,1,1,0H6a1,1,0,0,1,.707.293L11.414,5a2,2,0,0,1,0,2.829L7.828,11.414A1.993,1.993,0,0,1,6.414,12ZM2,5.586,6.414,10,10,6.414,5.586,2H2Z"></path>{" "}
				<circle cx="4" cy="4" r="1" data-color="color-2"></circle>
			</g>
		</svg>
	),
	image: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M10,0H2A2,2,0,0,0,0,2v8a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V2A2,2,0,0,0,10,0ZM2,2h8V8L7,5,2,10Z"></path>
				<circle cx="4" cy="4" r="1" data-color="color-2"></circle>
			</g>
		</svg>
	),
	export: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M10,7A1,1,0,0,0,9,8v2H2V3H3A1,1,0,0,0,3,1H2A2,2,0,0,0,0,3v7a2,2,0,0,0,2,2H9a2,2,0,0,0,2-2V8A1,1,0,0,0,10,7Z"></path>
				<path
					data-color="color-2"
					d="M8.82.116A.5.5,0,0,0,8,.5V2A4,4,0,0,0,4,6,1,1,0,0,0,6,6,2,2,0,0,1,8,4V5.5a.5.5,0,0,0,.288.453A.507.507,0,0,0,8.5,6a.5.5,0,0,0,.32-.116l3-2.5a.5.5,0,0,0,0-.768Z"
				></path>
			</g>
		</svg>
	),
	edit: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path
					data-color="color-2"
					d="M11.587.419,11.581.413a1.409,1.409,0,0,0-1.993,0h0L5.042,4.958a.257.257,0,0,0-.061.1l-.823,2.47a.25.25,0,0,0,.316.316l2.47-.823a.257.257,0,0,0,.1-.061l4.545-4.545a1.409,1.409,0,0,0,0-1.993Z"
				></path>
				<path d="M10,8A1,1,0,0,0,9,9v1H2V3H3A1,1,0,0,0,3,1H2A2,2,0,0,0,0,3v7a2,2,0,0,0,2,2H9a2,2,0,0,0,2-2V9A1,1,0,0,0,10,8Z"></path>
			</g>
		</svg>
	),
	login: (
		<svg x="0px" y="0px" width="16px" height="16px" viewBox="0 0 16 16">
			<g transform="translate(0, 0)">
				<circle data-color="color-2" cx="8" cy="7" r="3"></circle>{" "}
				<path d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M12,12.4c-0.6-0.7-1.4-1.4-3-1.4H7 c-1.6,0-2.4,0.7-3,1.4C2.8,11.3,2,9.8,2,8c0-3.3,2.7-6,6-6s6,2.7,6,6C14,9.8,13.2,11.3,12,12.4z"></path>
			</g>
		</svg>
	),
	loader: (
		<svg x="0px" y="0px" width="16px" height="16px" viewBox="0 0 16 16">
			<g transform="translate(0, 0)">
				<g>
					<path
						d="M8 16a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8zM8 2a6 6 0 1 0 6 6 6.006 6.006 0 0 0-6-6z"
						opacity=".4"
					></path>
					<path
						d="M8 0v2a6.006 6.006 0 0 1 6 6h2a8.009 8.009 0 0 0-8-8z"
						data-color="color-2"
					></path>
				</g>
			</g>
		</svg>
	),
	minus: (
		<svg x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<g transform="translate(0, 0)">
				<path d="M11,7H1A1,1,0,0,1,1,5H11a1,1,0,0,1,0,2Z"></path>
			</g>
		</svg>
	),
};
